import {FormattedMessage} from "react-intl";
import classnames from 'classnames';
import React from "react";

const GuideAssistantTooltip = props => {
  const {
    continuous,
    index,
    isLastStep,
    step,
    backProps,
    primaryProps,
    skipProps,
    tooltipProps,
  } = props;

  const cssBEM = 'guideAssistantTooltip';
  const classes = classnames(cssBEM);

  return (
    <div className={classes} {...tooltipProps}>
      { step.title && (
        <h2 className={`${cssBEM}__title`}>
          {step.title}
        </h2>
      )}

      { step.content && (
        <div className={`${cssBEM}__content`}>
          {step.content}
        </div>
      )}

      <div className={`${cssBEM}__footer`}>
        {!isLastStep && step.showSkipButton && (
          <button {...skipProps} className="gaBtn gaBtn--skip">
            <FormattedMessage id="assistant.skip" />
          </button>
        )}
        <div className={isLastStep ? 'last-step' : ''}>
          {index > 0 && !step.hideBackButton && (
            <button {...backProps} className="gaBtn gaBtn--back">
              <FormattedMessage id="assistant.back" />
            </button>
          )}
          <button {...primaryProps} className="gaBtn gaBtn--next">
            <FormattedMessage id={continuous && !isLastStep ? 'assistant.next' : 'assistant.close'} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuideAssistantTooltip;
